import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = ''
}: BadgeProps) {
  // IMPROVED: Better contrast, larger text, more padding
  const variants = {
    default: 'bg-slate-100 text-slate-700 border-slate-200',
    primary: 'bg-indigo-100 text-indigo-700 border-indigo-200',
    secondary: 'bg-purple-100 text-purple-700 border-purple-200',
    success: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    warning: 'bg-amber-100 text-amber-700 border-amber-200',
    danger: 'bg-rose-100 text-rose-700 border-rose-200',
    info: 'bg-blue-100 text-blue-700 border-blue-200',
    neutral: 'bg-slate-100 text-slate-700 border-slate-200',
    outline: 'bg-transparent text-slate-700 border-slate-300'
  };
  // IMPROVED: Larger sizes for better readability
  const sizes = {
    sm: 'px-2.5 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };
  return <span className={`
        inline-flex items-center gap-1.5 font-bold rounded-full border
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `} data-id="element-5400">

      {icon && <span className="flex-shrink-0" data-id="element-5401">{icon}</span>}
      {children}
    </span>;
}